import { connect } from 'react-redux';
import { 
  syncDataSource, 
  createRssDataSource,
  fetchDataSource,
  authenticateDataSource,
  deleteDataSource,
  migrateDataSource
} from 'src/redux/actions/dataSource.ts';
import {fetchAssetStorageLimit} from 'src/redux/actions/assets.ts';
import DataSourceView from './DataSourceView.jsx';
import {trackAdoptionMetricsForSourceTypeSelectedEvent,trackAdoptionMetricsForSourceConnectedEvent} from "src/legacy/redux/actions/adoption";
import hasAccess from 'src/legacy/services/hasAccess.jsx';
import _ from 'lodash';

const mapStateToProps = (state, ownProps) => {
  return {
    dataSources: _.get(state, "dataSource.items", []),
    oauth2: _.get(state, "dataSource.oauth2"),
    storageLimit: _.get(state, "asset.storageLimit"),
    isStorageLimitFetching : _.get(state, 'asset.storageLimit.fetching', null)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateDataSource: (sourceType, code) => {
      return dispatch(authenticateDataSource(sourceType, code));
    },

    syncSource: (id) =>{
      return dispatch(syncDataSource(id));
    },

    deleteSource: (id) =>{
      return dispatch(deleteDataSource(id));
    },

    fetchDataSource: (metadata) =>{
      return dispatch(fetchDataSource(metadata));
    },

    createRssDataSource: (sourceType, url) => {
      return dispatch(createRssDataSource(sourceType, url));
    },

    migrateDataSource: (id) => {
      return dispatch(migrateDataSource(id));
    },

    trackAdoptionMetricsForSourceTypeSelectedEvent: (sourceType) =>{
      return dispatch(trackAdoptionMetricsForSourceTypeSelectedEvent(sourceType))
    },
    
    trackAdoptionMetricsForSourceConnectedEvent: (sourceType) =>{
      return dispatch(trackAdoptionMetricsForSourceConnectedEvent(sourceType))
    },

    fetchAssetStorageLimit: () => {
      return dispatch(fetchAssetStorageLimit());
    }
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, {
    ...stateProps,
    ...dispatchProps,
    isAuthenticating: (sourceType) => {
      var oauth2 = stateProps.oauth2[sourceType];
      return oauth2 && oauth2.authenticating;
    }
  })
}


const DataSourcePage = connect (
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(DataSourceView);

export default DataSourcePage;
